import React from "react";
import ItemCircle from "./ItemCircle";
import arrayifyWithKey from "../../../helpers/arrayifyWithKey";
/*
  If the test is in progress, then each ItemCircle is either not answered, answered, or flagged. Also can be active.
  If it's a single student with complete test, each ItemCircle is either right or wrong. Also can be active.
  It it's a group of students, each ItemCircle has a color based on percentage.
*/

/*
  <ItemCircles 
    user={props.user}
    userAssessment={props.userAssessment}
    groupUA={props.groupUA}
    selectedStudent={props.selectedStudent}
    subtestId={props.subtestId}
    itemNumber={props.itemNumber}
    completed={props.completed}
    selectedGroupUA={props.selectedGroupUA}
  />
*/

export default function ItemCircles(props) {
  let itemCircles = [];
  let uA = props.userAssessment;
  let uAid = "";
  let isStudent = true;

  if (props.user.role !== "Student") {
    uA = props.groupUA;
    uAid = props.selectedGroupUA;
    isStudent = false;
  } else if (props.userAssessment) {
    uAid = props.userAssessment.userAssessmentId;
  }
  if (uA) {
    let destructuredSubtest, scoring, answersByItem;
    uA.destructuredSubtests
      ? (destructuredSubtest = uA.destructuredSubtests[props.subtestId].items)
      : null;
    uA.scoring ? (scoring = uA.scoring.byItem[props.subtestId]) : null;
    uA.answersByItem
      ? (answersByItem = uA.answersByItem[props.subtestId])
      : null;
    

    if (!props.completed) {
      destructuredSubtest.forEach((item, n) => {
        let answer_data = props.items && props.items[item];
        for (let x in answer_data) {
          var obj = answer_data[x];
        }
        itemCircles.push(
          <ItemCircle
            number={n + 1}
            uAid={uAid}
            subtestId={props.subtestId}
            active={n + 1 == props.itemNumber}
            completed={props.completed}
            answer={answersByItem ? answersByItem[item] : null}
            key={`ItemCircle${n}`}
            assessmentId={props.assessmentId}
            isStudent={isStudent}
            selectedStudent={props.selectedStudent}
          />
        );
      });
    } else {
      destructuredSubtest.forEach((item, n) => {
        var result = [];
        if(props.items){
        let answer_data = props.items && props.items[item].answers;
        result = Object.keys(answer_data).map(function(key) {
          return [key, answer_data[key]];
        });
      }
        let correct_answer = "";
        for (let x in result) {
          let obj = result[x];
          let correct = obj[1].correct;
          if (correct) {
            correct_answer = obj[0];
          }
        }
       
        itemCircles.push(
          <ItemCircle
            number={n + 1}
            uAid={uAid}
            subtestId={props.subtestId}
            active={n + 1 == props.itemNumber}
            completed={true}
            scoring={scoring[item]}
            key={`ItemCircle${n}`}
            isStudent={isStudent}
            answer={answersByItem ? answersByItem[item] : null}
            assessmentId={props.assessmentId}
            selectedStudent={props.selectedStudent}
            correct_answer={correct_answer}
          />
        );
      });
    }
  }
  return <ul>{itemCircles}</ul>;
}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemCircles.js